"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Nav = _interopRequireDefault(require("react-bootstrap/Nav"));
var _Navbar = _interopRequireDefault(require("react-bootstrap/Navbar"));
var _reactBootstrap = require("react-bootstrap");
var _link = require("../link");
var _SecondTierMegaNav = _interopRequireDefault(require("./SecondTierMegaNav"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SecondTier = _ref => {
  let {
    expanded,
    trunk
  } = _ref;
  let currentAudience = trunk?.navheader?.siteNav?.find(audience => audience.active);
  const optionalBranding = trunk => {
    if (!trunk.navheader?.navSettings?.brandDisplayText || trunk.navheader?.navSettings.brandDisplayText === '') {
      return null;
    } else {
      return /*#__PURE__*/_react.default.createElement(_Navbar.default.Brand, {
        href: (0, _link.absolute)({
          url: trunk.navheader.navSettings.brandUrl
        }),
        rel: "noopener noreferer",
        "aria-label": `${trunk.navheader.navSettings.brandDisplayText} Home`
      }, trunk.navheader.navSettings.brandDisplayText);
    }
  };
  const simple = !trunk.navheader?.utilityNav || trunk.navheader.utilityNav.length == 0;
  const credsDiv = document.createElement('div');
  credsDiv.className = 'credentials';
  if (simple) {
    credsDiv.classList.add('simple');
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement(_Navbar.default.Collapse, {
    id: "main-nav--dropdowns",
    className: `${expanded ? 'show' : ''}`
  }, trunk.navheader?.siteNav && /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown, {
    title: currentAudience.label,
    id: "mobileAudienceDropdown",
    className: "dropdown audience-mobile"
  }, trunk.navheader?.siteNav?.map(audience => {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown.Item, {
      key: audience.label,
      href: (0, _link.absolute)(audience.link)
    }, audience.label);
  })), optionalBranding(trunk), /*#__PURE__*/_react.default.createElement(_SecondTierMegaNav.default, {
    trunk: trunk
  }), !simple && /*#__PURE__*/_react.default.createElement(_Nav.default, {
    className: "secondary"
  }, trunk.navheader.utilityNav.map(item => {
    return /*#__PURE__*/_react.default.createElement(_Nav.default.Item, {
      key: item.label
    }, /*#__PURE__*/_react.default.createElement(_Nav.default.Link, {
      href: (0, _link.absolute)(item.link)
    }, item.label));
  })), /*#__PURE__*/_react.default.createElement(_Nav.default, {
    className: credsDiv.classList.value
  }, trunk.navheader?.siteUtilityNav?.map(item => {
    if (!item.highlight) {
      return /*#__PURE__*/_react.default.createElement(_Nav.default.Item, {
        key: item.label
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "nav-link",
        href: (0, _link.absolute)(item.link),
        title: item.label
      }, item.label));
    }
    return /*#__PURE__*/_react.default.createElement(_Nav.default.Item, {
      key: item.label
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "btn btn-secondary",
      href: (0, _link.absolute)(item.link),
      title: item.label
    }, item.label));
  }))));
};
SecondTier.propTypes = {
  expanded: _propTypes.default.bool,
  trunk: _propTypes.default.any
};
var _default = exports.default = SecondTier;